import { BaseService } from "./BaseService";

export const ProgramaService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('programa/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos programas:', error);
            return false;
        }
    },
    async store(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('programa', postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a criação de programas:', error);
            return false;
        }
    },
    async select(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIGet('programa/select', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos programas:', error);
            return false;
        }
    },
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`programa/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca de programas:', error);
            return false;
        }
    }, 
    async update(id, postData) {
        try {
            postData.append("_method", "PUT");
            return await BaseService.fetchResponseFromAPIPost(`programa/${id}`, postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a atualização de programas:', error);
            return false;
        }
    }, 
    async destroy(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('programa/destroy', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao excluir programas:', error);
            return false;
        }
    }, 
    async activate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('programa/activate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao ativar programas:', error);
            return false;
        }
    }, 
    async deactivate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('programa/deactivate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao desativar programas:', error);
            return false;
        }
    }, 
}